import { keepPreviousData, useQuery } from '@tanstack/react-query';

import getHostPromoList from 'Api/host-stock-promo/getHostPromoList';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import getHostPromoListRequest from './model/request/getHostPromoListRequest';
import getHostPromoListResponse from './model/response/getHostPromoListResponse';

const useGetHostPromoList = ({ params, enabled }) => {
  const { state, updateState } = useHostStockPromoState();

  return useQuery({
    queryKey: ['host-promo-list', params],
    queryFn: async () => {
      const queries = getHostPromoListRequest(params);

      const response = await getHostPromoList(queries);

      const result = getHostPromoListResponse(response, state.previousPromotions, params?.page);

      updateState({ previousPromotions: result?.promotions });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
    placeholderData: keepPreviousData,
  });
};

export default useGetHostPromoList;
